import { IconButton } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { Linked, useLinked } from "@type-r/react";
import { CollapsableSection, Column, Flex, asDateTime } from "lqx-react/lib";
import React from "react";
import { AssetTypesDisplay } from "../api/assetType";
import { ImportTemplateCard } from "../api/importTemplateCard";
import { HeaderTitle } from "../components/asset-details-pane-styles";
import { CopyRow } from "../components/copy-row";
import { DetailsPaneActionsContainer, DetailsPaneContainer, DetailsPaneHeader, DetailsPaneStatus, DetailsPaneTab, DetailsPaneTabContent, DetailsPaneTabs, colorStyles, detailsPanelStyles } from "../components/item-card-styles";
import { ValidationRulesActions } from "./validation-rules-actions";
import { ValidationRuleItem } from "../api/validationRuleItem";
import { Can } from "src/app/services/can";
import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";

export const ValidationRulesDetailsPane = ({ $activeCard, onDelete }: { $activeCard: Linked<ValidationRuleItem>, onDelete: any }) => {
    const $selectedTab = useLinked('details');
    const classes = detailsPanelStyles();
    const colorClasses = colorStyles();
    const importTemplateStatus = () => $activeCard && $activeCard.value.isActive ?
        <span className={colorClasses.active}>Active</span> : <span className={colorClasses.inactive}>Inactive</span>

    return (
        <>
            <DetailsPaneContainer>
                <DetailsPaneHeader>
                    <IconButton aria-label="Close" size="small" className={classes.iconButton} onClick={() => $activeCard.set(null)}>
                        <CloseIcon />
                    </IconButton>
                    <Flex alignCenter>
                        <DetailsPaneStatus>{importTemplateStatus()}</DetailsPaneStatus>
                    </Flex>
                    <Flex>
                        <HeaderTitle><>Validation Set {$activeCard.value.id}</></HeaderTitle>
                    </Flex>
                </DetailsPaneHeader>
                <DetailsPaneActionsContainer>
                    {Can(UserEntitlementCatalogs.EditValidationRulePage) &&
                        <ValidationRulesActions validationCard={$activeCard.value} onDelete={onDelete} />
                    }
                </DetailsPaneActionsContainer>
                <DetailsPaneTabs value={$selectedTab.value}
                    variant="scrollable"
                    scrollButtons="auto"
                    onChange={(_, newValue) => $selectedTab.set(newValue)} >
                    <DetailsPaneTab value="details" label=" Details" />
                </DetailsPaneTabs>
                <DetailsPaneTabContent>
                    {$selectedTab.value === 'details' && <Details classes={classes} validationCard={$activeCard.value} />}
                </DetailsPaneTabContent>
            </DetailsPaneContainer>
        </>
    )
};

const Details = ({ classes, validationCard }: { classes: any, validationCard: ImportTemplateCard }) => {
    return (
        <>
            <CollapsableSection title='General' titleClassName={classes.sectionTitle} noBorder noShadow >
                <Column>
                    <CopyRow label='Name' value={validationCard.name} />
                    <CopyRow label='Companies' value={validationCard.companies.map(company => company.name).join(', ')} />
                    <CopyRow label='Asset Types' value={AssetTypesDisplay[validationCard.assetTypeId]} />
                    <CopyRow label='Created By' value={validationCard.createdBy} />
                    <CopyRow label='Created On' value={asDateTime(validationCard.createdOn)} />
                    <CopyRow label='Updated On' value={asDateTime(validationCard.updatedOn)} />
                </Column>
            </CollapsableSection>
        </>
    )
}; 